import { Routes, Route, Navigate } from "react-router";
import { Layout } from "./components/Layout";
import { LegacyRedirect } from "./components/LegacyRedirect";
import { LEGACY_REDIRECTS } from "./lib/redirects";
import { Overview } from "./pages/Overview";
import { Pipelines } from "./pages/Pipelines";
import { Pipeline } from "./pages/Pipeline";
import { PipelineWizard } from "./pages/PipelineWizard";
import { PipelineEditor } from "./pages/PipelineEditor";
import { Activity } from "./pages/Activity";
import { Run } from "./pages/Run";
import { NeedsAttention } from "./pages/NeedsAttention";
import { Connections } from "./pages/Connections";
import { Connection } from "./pages/Connection";
import { ConnectionEditor } from "./pages/ConnectionEditor";
import { Catalog } from "./pages/Catalog";
import { CatalogConnector } from "./pages/CatalogConnector";
import { CatalogTransform } from "./pages/CatalogTransform";
import { Environments } from "./pages/Environments";
import { Secrets } from "./pages/Secrets";
import { Clients } from "./pages/Clients";
import { ClientWorkspace } from "./pages/client/ClientWorkspace";
import { ClientOverview } from "./pages/client/ClientOverview";
import { ClientPipelines } from "./pages/client/ClientPipelines";
import { ClientConnections } from "./pages/client/ClientConnections";
import { ClientActivity } from "./pages/client/ClientActivity";
import { ClientAttention } from "./pages/client/ClientAttention";
import { ClientSettings } from "./pages/client/ClientSettings";
import { Docs } from "./pages/Docs";
import { Glossary } from "./pages/Glossary";
import { Queues } from "./pages/Queues";
import { NotFound } from "./pages/NotFound";

/**
 * Every route in the admin UI (spec §3.2).
 *
 * CS home is `/clients`, and the client workspace is a layout route whose
 * tabbed children share one header and one data context. Pre-SP1 URLs redirect
 * with `replace`, so an old bookmark lands on the new page without leaving the
 * dead URL in the operator's history.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/clients" replace />} />
        <Route path="clients" element={<Clients />} />
        <Route path="clients/:id" element={<ClientWorkspace />}>
          <Route index element={<ClientOverview />} />
          <Route path="pipelines" element={<ClientPipelines />} />
          <Route path="connections" element={<ClientConnections />} />
          <Route path="activity" element={<ClientActivity />} />
          <Route path="attention" element={<ClientAttention />} />
          <Route path="settings" element={<ClientSettings />} />
        </Route>
        <Route path="activity" element={<Activity />} />
        <Route path="activity/:id" element={<Run />} />
        <Route path="attention" element={<NeedsAttention />} />
        <Route path="overview" element={<Overview />} />
        <Route path="pipelines" element={<Pipelines />} />
        <Route path="pipelines/:id" element={<Pipeline />} />
        <Route path="pipelines/:id/edit" element={<PipelineEditor />} />
        <Route path="pipelines/new" element={<PipelineWizard />} />
        <Route path="connections" element={<Connections />} />
        <Route path="connections/new" element={<ConnectionEditor />} />
        <Route path="connections/:id" element={<Connection />} />
        <Route path="connections/:id/edit" element={<ConnectionEditor />} />
        <Route path="catalog" element={<Catalog />} />
        <Route path="catalog/connectors/:type" element={<CatalogConnector />} />
        <Route path="catalog/transforms/:id" element={<CatalogTransform />} />
        <Route path="environments" element={<Environments />} />
        <Route path="queues" element={<Queues />} />
        <Route path="secrets" element={<Secrets />} />
        <Route path="docs" element={<Docs />} />
        <Route path="docs/:slug" element={<Docs />} />
        <Route path="glossary" element={<Glossary />} />
        {LEGACY_REDIRECTS.map((r) => (
          <Route key={r.from} path={r.from} element={<LegacyRedirect to={r.to} />} />
        ))}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
